import UserProvider from "../../context/userContext";
import TechProvider from "../../context/TechContext"

const ContextProviders = ({children})=>{

    return(
        <>
            <TechProvider>
                <UserProvider>
                    {children}
                </UserProvider>
            </TechProvider>
        </>
    )
}

export default ContextProviders;